import { reportingColors } from "features/Library/Common/utils/constants";
import type { CopilotAppKey, CopilotAppSuffix } from "./types";

export const COPILOT_APP_DISPLAY: Record<CopilotAppKey, CopilotAppSuffix> = {
  copilot_word: "Word",
  copilot_power_point: "PowerPoint",
  copilot_outlook: "Outlook",
  copilot_one_note: "OneNote",
  copilot_msft_teams: "Teams",
  copilot_loop: "Loop",
  copilot_excel: "Excel",
} as const;

export const COPILOT_APP_COLOR: Record<CopilotAppKey, string> = {
  copilot_msft_teams: reportingColors.blue,
  copilot_word: reportingColors.yellow,
  copilot_excel: reportingColors.greenDark,
  copilot_power_point: reportingColors.red,
  copilot_outlook: reportingColors.greenLight,
  copilot_one_note: reportingColors.purple,
  copilot_loop: reportingColors.blueLight,
} as const;
